import type { FC } from 'react'
import BaseModal from './BaseModal'
import './styles.css'
import { LoadingIndicator } from '../LoadingIndicator/LoadingIndicator'

interface ConfirmModalProps {
  isOpen: boolean
  title?: string
  message: string
  onConfirm: () => void
  onClose: () => void
  isConfirmLoading?: boolean
}

const ConfirmationModal: FC<ConfirmModalProps> = ({
  isOpen,
  title,
  message,
  onConfirm,
  onClose,
  isConfirmLoading = false,
}) => {
  const footer = (
    <div className="modal-actions">
      <button
        type="button"
        className="modal-button modal-button-primary"
        onClick={onConfirm}
        disabled={isConfirmLoading}
      >
        {isConfirmLoading ? <LoadingIndicator style="INLINE" /> : 'Confirm'}
      </button>
      <button type="button" className="modal-button modal-button-secondary" onClick={onClose}>
        Back
      </button>
    </div>
  )

  return (
    <BaseModal isOpen={isOpen} title={title || 'Confirmation'} onClose={onClose} footer={footer}>
      <p>{message}</p>
    </BaseModal>
  )
}

export default ConfirmationModal
